import { UserCenterEntityType } from './UserCenterEntityType';

export class KVEntityDto {
    entityType: UserCenterEntityType;
    entityId: string;
    content: string;
}
